import { render, staticRenderFns } from "./MonthList.vue?vue&type=template&id=f2f19cc8&scoped=true&"
import script from "./MonthList.vue?vue&type=script&lang=ts&"
export * from "./MonthList.vue?vue&type=script&lang=ts&"
import style0 from "./MonthList.vue?vue&type=style&index=0&id=f2f19cc8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2f19cc8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VRow})
